import { Image } from "react-grid-gallery";
import currentImage from './galleryImages.json';

export interface CustomImage extends Image {
  original: string;
}

export const images: CustomImage[] = currentImage